export default "__VITE_ASSET__BSsEIb6___"